module.exports = __webpack_public_path__ + "static/media/trip-attack-card.15abdf50.wav";